(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ignitionTween", [], factory);
	else if(typeof exports === 'object')
		exports["ignitionTween"] = factory();
	else
		root["ignitionTween"] = factory();
})(self, () => {
return 